export const sessionSchema = `
    id
    name
    startDate
    endDate
    ... on HoranetSession {
      visibleOnline
      allowReservation
      horanetStatus
      codeSiteComptage: workspace
      participantsAmount: contractsCount
      recurring_uuid: recurringUuid
      recurring
      isTerrainSession
      activity
      capacity: capacitySoldOnline
      max_participant: participantsStock
      serviceIds{
        id
        name
      }
      contracts {
        metadata {
          reservationAmount
        }
      }
    }
`;

export const contractSchema = `
  session {
    ${sessionSchema}
  }
`;
